// extracted by mini-css-extract-plugin
module.exports = {"loadingDots":"loading_loadingDots__sE3bm","dotFlashing":"loading_dotFlashing__VoAmm","loadingOverlay":"loading_loadingOverlay__Kt3YX","loader":"loading_loader__u5lZQ"};